<template>
    <div style="position:relative;">
      <div style="text-align: center">
        <h2>Working with us</h2>
        <div class="section">
          <h1>01</h1>
          <p>Get in touch for a free consultation</p>
        </div>
        <div class="section">
          <h1 style="color: #AAAEBA">02</h1>
          <p>Help us understand what you are looking to achieve</p>
        </div>
        <div class="section">
          <h1 style="color: #787c88">03</h1>
          <p>See if there is a good fit</p>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'WorkingWithUs',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  h1 {
    font-size: 160px;
    margin: 0;
    color: #dbdbdb;
    position: relative;
  }

  p {
    width: 160px;
    position: relative;
    text-align: left;
    top: -100px;
    font-weight: bold;
    font-size: 20px;
    margin: 0;
    line-height: 1;
  }

  .section {
    min-width: 420px;
    display: inline-block;
    width: 30%;
    height: 300px;
    vertical-align: top;
    clear: both;
  }

  @media only screen and (max-width: 1280px) {
    .section {
      display: block;
      margin: auto;
      min-width: 320px;
    }
  }

</style>
